module.exports = __webpack_public_path__ + "img/calendar.493af0b7.svg";